import { ReactNode } from 'react'
import { Theme } from '@mui/material'
import MdButton from '@mui/material/Button'
import CircularProgress from '@mui/material/CircularProgress'
import { SxProps } from '@mui/system'

type Props = {
  children: ReactNode
  disabled?: boolean
  onClick: () => void
  loading?: boolean
  type?: 'button' | 'submit'
  size?: 'large' | 'medium' | 'small'
  variant?: 'outlined' | 'text' | 'contained'
  sx?: SxProps<Theme>
}

export default function ButtonPrimaryOutlined({
  children,
  loading,
  size = 'medium',
  variant = 'outlined',
  sx = {},
  ...rest
}: Props): JSX.Element {
  return (
    <MdButton
      {...rest}
      size={size}
      variant={variant}
      startIcon={loading ? <CircularProgress size={18} /> : null}
      sx={sx}
    >
      {children}
    </MdButton>
  )
}
